import { LocalStorageKeys } from '@/types';
import { setAuthItem } from '@/plugins/auth-storage';
import { getDeepLinkTargetUrl, isDeepLinkQuery } from '@/utils/deep-link';
export default (function (_a) {
    var route = _a.route;
    var isDeepLink = isDeepLinkQuery(route.query) || !!getDeepLinkTargetUrl(route.fullPath);
    if (route.fullPath.startsWith('/companies') && !isDeepLink) {
        setAuthItem(LocalStorageKeys.LastURL, route.fullPath);
    }
});
